import { render, staticRenderFns } from "./MspForsageMember.vue?vue&type=template&id=6665e074"
import script from "./MspForsageMember.vue?vue&type=script&lang=js"
export * from "./MspForsageMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports